module.exports = __webpack_public_path__ + "media/ambience-changing-room.11f9fd8a.mp3";